import PageUniversalLink from 'components/PageUniversalLink';
import ErrorView from 'pages/ErrorView';
import {SearchingBookingModal} from '../../components/SearchingBookingModal';
import {useDirectReservation} from './useDirectReservation';

function DirectReservationView() {
  const {params, modalStatus, errorMessage} = useDirectReservation();

  if (!params) {
    return <ErrorView />;
  }

  return (
    <PageUniversalLink className="direct-reservation-view">
      {errorMessage ? (
        <div className="flex flex-col items-center justify-center gap-4 p-8">
          <div className="text-lg font-semibold text-center text-primary">
            {errorMessage}
          </div>
        </div>
      ) : (
        <SearchingBookingModal isOpen status={modalStatus} />
      )}
    </PageUniversalLink>
  );
}

export {DirectReservationView};
